import BulkPriceUpdateVM from './bulk-price-update-vm';

export default {
  init() {
    const validationOptions = {
      insertMessages: false,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true,
      grouping: { deep: true, observable: true, live: true }
    };

    var bulk_update_sale_data = JSON.parse($('#bulk_update_sales_json').val());
    const vm = new BulkPriceUpdateVM(bulk_update_sale_data);

    ko.applyBindingsWithValidation(
      vm,
      document.getElementById('bulk_price_updates'),
      validationOptions
    );
  }
};